import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { Icon } from '~/components';

export const TabIcon = styled(Icon)`
  display: none;
  width: 21px;
  width: 21px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: block;
  }
`;

export const CustomNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, color }) => theme[color]};
  width: 100%;
  height: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column;
    font-size: ${({ theme }) => theme.label}px;
  }
`;
